import { render, staticRenderFns } from "./MyProfileButton.vue?vue&type=template&id=0273a43c&scoped=true&"
import script from "./MyProfileButton.vue?vue&type=script&lang=js&"
export * from "./MyProfileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0273a43c",
  null
  
)

export default component.exports